<template>
  <div class="content">
    <div class="left">
      <div style="display: flex; flex-direction: column; margin-bottom: 30px">
        <span style="font-size: 24px; color: #333333; margin-bottom: 20px">{{
          $t("profile.monitorPage.title")
        }}</span>
        <div>
          <el-button type="primary" @click="openDialog">{{
            $t("profile.monitorPage.addAccount")
          }}</el-button>
        </div>
      </div>
      <div class="form">
        <el-table :data="tabletData" style="width: 100%">
          <el-table-column
            prop="loginName"
            :label="$t('profile.monitorPage.loginAccount')"
          >
          </el-table-column>
          <el-table-column
            prop="userName"
            :label="$t('profile.monitorPage.accountName')"
          >
          </el-table-column>
          <el-table-column
            prop="oper"
            :label="$t('profile.monitorPage.operations')"
          >
            <template slot-scope="scope">
              <el-button
                @click="deleteRow(scope.row?.id)"
                type="text"
                size="small"
                >{{ $t("profile.monitorPage.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- <div class="right">
      <div class="info">
        <img
          :src="avatarUrl"
          style="width: 80px; margin-left: 5px; margin-bottom: 20px"
          alt=""
        /><span style="font-size: 18px; color: #333333; margin-bottom: 20px">{{
          userInfo?.userName
        }}</span
        ><span style="font-size: 14px; color: #999999">{{
          userInfo?.deptName
        }}</span>
      </div>
      <div class="idNumber">
        <span style="margin-bottom: 12px"
          >{{ $t("profile.studentStaffID") }}：</span
        ><span>{{ $t("profile.phone") }}：{{ userInfo?.phone }}</span>
      </div>
    </div> -->
    <el-dialog
      title="添加监控账号"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="400px"
    >
      <!-- 表单内容 -->
      <el-form
        ref="verifyForm"
        :model="form"
        :rules="rules"
        label-width="100px"
        class="verify-form"
      >
        <!-- 学工号 -->
        <el-form-item label="学工号" prop="studentId">
          <el-input
            v-model="form.studentId"
            placeholder="请输入学工号"
            maxlength="20"
          ></el-input>
        </el-form-item>

        <!-- 证件号 -->
        <el-form-item label="证件号" prop="idNumber">
          <el-input
            v-model="form.idNumber"
            placeholder="请输入证件号码"
            maxlength="18"
          ></el-input>
        </el-form-item>
      </el-form>

      <!-- 弹窗底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getImageUrl } from "@/utils/imageHelper";
import request from "@/api/request";
export default {
  data() {
    return {
      avtor: require("@/assets/img/personal/avtor.png"),
      userInfo: {},
      tabletData: [],
      // 控制弹窗显示/隐藏
      dialogVisible: false,
      // 表单数据
      form: {
        studentId: "",
        idNumber: "",
      },
      // 验证规则
      rules: {
        studentId: [
          { required: true, message: "请输入学工号", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "学工号长度在 2 到 20 个字符之间",
            trigger: "blur",
          },
        ],
        idNumber: [
          { required: true, message: "请输入证件号", trigger: "blur" },
          {
            min: 6,
            max: 18,
            message: "证件号长度在 6 到 18 个字符之间",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    // 计算属性方式
    avatarUrl() {
      return getImageUrl(this.avtor);
    },
  },
  created() {
    this.userInfo = {
      ...JSON.parse(localStorage.getItem("accountInfo"))?.data,
    };
    this.avtor = this.userInfo.avatar;
    this.getTableData();
  },
  methods: {
    deleteRow(id) {
      request({
        url: `/api/user/monitor/del?id=${id}`,
        method: "get",
      })
        .then((res) => {
          this.$message.success("删除成功");
          this.getTableData()
        })
        .catch((error) => {});
    },
    openDialog() {
      this.dialogVisible = true;
    },
    submitForm() {
      this.$refs.verifyForm.validate((valid) => {
        if (valid) {
          // 表单验证通过，处理提交逻辑
          request({
            url: `/api/user/monitor/account`,
            method: "post",
            data: {
              loginname: this.form?.studentId,
              identity: this.form?.idNumber,
            },
          })
            .then((res) => {
              this.$message.success("信息验证成功");
              this.getTableData();
            })
            .catch((error) => {});

          console.log("提交的信息:", this.form);

          // 关闭弹窗
          this.dialogVisible = false;

          // 重置表单
          this.$refs.verifyForm.resetFields();
        } else {
          this.$message.error("请完善表单信息");
          return false;
        }
      });
    },
    getTableData() {
      request({
        url: `/api/user/monitor/list`,
        method: "get",
      })
        .then((res) => {
          this.tabletData = [...res];
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  // display: grid;
  // grid-template-columns: 4fr 1.3fr;
  height: 600px;
  .left {
    // border-right: 1px solid #dfdfdf;
    // width: 75%;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 20px;
    .form {
      ::v-deep .el-table__header th {
        background-color: #f5f7fb;
        font-weight: bold;
        color: #333333;
      }
    }
  }
  .right {
    background-image: url("@/assets/img/personal/editPassBg.png");
    background-size: contain;
    background-repeat: no-repeat;
    height: 100%;
    // width: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .info {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20%;
    }
    .idNumber {
      display: flex;
      flex-direction: column;
      padding: 15px;
      font-size: 14px;
      color: #666666;
      background: #f5f7fb;
      border-radius: 4px;
      width: 80%;
      margin-top: 15px;
    }
  }
}
</style>
